import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { ProductForm } from '../../app/components/forms/product';
import { trpc } from '@org/clients/school';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/products/new')({
  component: ProductCreateRoute,
});

function ProductCreateRoute() {
  const navigate = useNavigate({ from: '/products/new' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');

  const handleClose = () => {
    navigate({ to: '/products', replace: true });
  };

  const handleSubmit = async () => {
    await utils.products.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('products.list.modal.createTitle')}
      size="lg"
      centered
      body={
        <ProductForm
          defaultValues={{}}
          onSubmit={handleSubmit}
          onClose={handleClose}
        />
      }
      footer={<></>}
    />
  );
}
